// extracted by mini-css-extract-plugin
export default {"flipHorizontally":"Icons_flipHorizontally__1gezY","size12":"Icons_size12__tXR02"};